import { Link } from 'react-router-dom'
import { TrafficLightDot } from '@/components/PostureIndicator'
import { TRAFFIC } from '@/lib/trafficLight'
import { cn } from '@/lib/utils'

const STACK_STATUSES = ['red', 'amber', 'green']

export function CustomerPostureStack({ customerId, counts = {}, className }) {
  return (
    <div
      className={cn('flex shrink-0 flex-col justify-center gap-2.5 border-l border-border pl-3', className)}
      onClick={(event) => event.stopPropagation()}
    >
      {STACK_STATUSES.map((status) => {
        const count = counts[status] ?? 0
        const traffic = TRAFFIC[status]
        const clickable = count > 0

        const content = (
          <>
            <TrafficLightDot status={status} className="h-5 w-5" />
            <span className="min-w-[1.25rem] text-base font-semibold tabular-nums leading-none">
              {count}
            </span>
            <span className="sr-only">{traffic.label}</span>
          </>
        )

        const rowClass = 'flex items-center gap-2'

        if (!clickable) {
          return (
            <div
              key={status}
              className={cn(rowClass, 'opacity-35')}
              title={`No devices — ${traffic.label}`}
            >
              {content}
            </div>
          )
        }

        return (
          <Link
            key={status}
            to={`/customers/${customerId}?posture=${status}`}
            className={cn(rowClass, 'rounded-md px-1.5 py-0.5 transition-colors hover:bg-muted/60')}
            title={`${count} device${count === 1 ? '' : 's'} — ${traffic.label}`}
          >
            {content}
          </Link>
        )
      })}
    </div>
  )
}
